import { render, staticRenderFns } from "./oldXszm.vue?vue&type=template&id=74e16fd5&scoped=true"
import script from "./oldXszm.vue?vue&type=script&lang=js"
export * from "./oldXszm.vue?vue&type=script&lang=js"
import style0 from "./oldXszm.vue?vue&type=style&index=0&id=74e16fd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e16fd5",
  null
  
)

export default component.exports